module.exports = __webpack_public_path__ + "static/media/progclublogo.ff0cea2c.jpg";